import styled from 'styled-components'
import { desktopBreakpoint, tabletBreakpoint } from 'react-components'

interface Props {
    href: string
}

export const Container = styled.section`
    background-color: ${props => props.theme.colors.tfwBlack3};
    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        padding: 2.125rem 1.25rem;
    }
`

export const InnerContainer = styled.div`
    display: ${props => props.theme.style.display.flex};
    justify-content: ${props => props.theme.style.justifyContent.center};
    flex-direction: ${props => props.theme.style.flexDirection.column};

    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        /* For desktops: */
        flex-direction: ${props => props.theme.style.flexDirection.row};
        align-items: ${props => props.theme.style.alignItems.center};
        justify-content: ${({ theme }) => theme.style.justifyContent.spaceBetween};
        max-width: 1110px;
        margin: 0 auto;
    }
`

export const ContentContainer = styled.div`
    display: ${props => props.theme.style.display.flex};
    justify-content: ${props => props.theme.style.justifyContent.center};
    flex-direction: ${props => props.theme.style.flexDirection.column};
`

export const ContactImgContent = styled.img`
    border-radius: 50%;
    width: 3.125rem;
`

export const ContactDetailsContainer = styled.div`
    display: ${({ theme }) => theme.style.display.flex};
    flex-direction: ${({ theme }) => theme.style.flexDirection.column};
    justify-content: ${({ theme }) => theme.style.justifyContent.spaceAround};
    line-height: normal;
    color: ${props => props.theme.colors.tfwBlack87};
`

export const ContactNumberContainer = styled.a`
    font-family: ${props => props.theme.typography.font.family.yummo};
    font-size: ${props => props.theme.typography.font.size.large};
    font-weight: bold;
    color: ${props => props.theme.colors.tfwBlack87};
    text-decoration: none;
    &:link,
    &:visited {
        text-decoration: none;
        color: ${props => props.theme.colors.tfwBlack87};
    }

    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        /* For tablets: */
        font-size: ${props => props.theme.typography.font.size.xLarge};
        font-family: ${props => props.theme.typography.font.family.yummo};
    }
`

export const ContactEmailContainer = styled.div`
    font-family: ${props => props.theme.typography.font.family.lato};
    font-size: ${props => props.theme.typography.font.size.medium};
    color: ${props => props.theme.colors.tfwBlack87};
    line-height: normal;
    font-weight: 300;
`

export const CustomerSupportParaContent = styled.p`
    margin: 0.625rem;
    font-family: ${props => props.theme.typography.font.family.lato};
    font-size: ${props => props.theme.typography.font.size.medium};
    font-weight: 300;
    line-height: normal;
    text-align: ${props => props.theme.style.textAlign.center};
    color: ${props => props.theme.colors.tfwBlack87};

    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        /* For tablets: */
        margin: 1.875rem 1.25rem 0.625rem;
        font-size: ${props => props.theme.typography.font.size.xLarge};
        font-family: ${props => props.theme.typography.font.family.yummo};
    }
    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        /* For desktops: */
        text-align: ${props => props.theme.style.textAlign.left};
        margin: 0 0 0.625rem;
    }
`

export const CustomerSupportBoldParaContent = styled.p`
    margin: 0px 0.625rem 1.875rem;
    font-family: ${props => props.theme.typography.font.family.lato};
    font-size: ${props => props.theme.typography.font.size.medium};
    font-weight: bold;
    line-height: normal;
    text-align: ${props => props.theme.style.textAlign.center};
    color: ${props => props.theme.colors.tfwBlack87};

    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        /* For tablets: */
        font-size: ${props => props.theme.typography.font.size.xLarge};
        font-family: ${props => props.theme.typography.font.family.yummo};
    }
    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        /* For desktops: */
        text-align: ${props => props.theme.style.textAlign.left};
        margin: 0;
    }
`

export const ChatMessageBoxContainer = styled.div`
    margin: 1.875rem 0 0.75rem;
    display: ${props => props.theme.style.display.flex};
    justify-content: ${props => props.theme.style.justifyContent.center};

    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        /* For desktops: */
        min-width: 22.25rem;
        margin: 0 1.9375rem 0 0;
        justify-content: ${({ theme }) => theme.style.justifyContent.flexStart};
    }
`

export const EmailLinkContent = styled.a<Props>`
    font-family: ${props => props.theme.typography.font.family.lato};
    color: ${props => props.theme.colors.tfwBlack87};
    font-weight: normal;
`

export const ChatMessageContent = styled.div`
    padding: 0.8125rem 0.6875rem 0.8125rem 0.9375rem;
    display: ${({ theme }) => theme.style.display.flex};
    flex-direction: ${({ theme }) => theme.style.flexDirection.row};
    justify-content: ${({ theme }) => theme.style.justifyContent.spaceBetween};
    align-items: ${({ theme }) => theme.style.alignItems.center};
    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        padding: 0.9375rem;
    }
`
export const ContactImageContainer = styled.div`
    margin-right: 0.625rem;
`
